import React, { ChangeEvent } from 'react';
import { Input, Button, Row, Col, Form, FormGroup } from 'reactstrap';
import Viewer from 'react-viewer';
import moment from 'moment';

function RenovacionForm(props: any) {
  const {
    data,
    setData,
    gallery,
    galleryContainer,
    isLoading,
    onChangeState,
  } = props;

  const actionsByState = () => {
    if (data.state_id != '' && onChangeState) {
      switch (data.state_id) {
        case 1:
          return (<Row id="actions-row">
            <hr className="my-4" />
            <Col sm={6}>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Motivo de rechazo</label>
                    <Input
                      id="motivo_rechazo"
                      name="motivo_rechazo"
                      type="textarea"
                      value={data.motivo_rechazo ?? ''}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col sm={12} className="text-center">
              <Button color="danger" onClick={ () => onChangeState(3) } disabled={ isLoading }>Rechazar</Button>
              <Button color="success" onClick={ () => onChangeState(2) } disabled={ isLoading }>Aceptar</Button>
            </Col>
          </Row>);
          break;
        case 2:
          return (<Row id="actions-row">
            <hr className="my-4" />
            <Col sm={6}>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Número Gestión</label>
                    <Input
                      id="numero_gestion"
                      name="numero_gestion"
                      type="number"
                      value={data.numero_gestion ?? ''}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col sm={12} className="text-center">
              <Button color="primary" onClick={() => onChangeState(5)} disabled={isLoading}>Enviado Ministerio</Button>
            </Col>
          </Row>);
          break;
        case 5:
          return (<Row id="actions-row">
            <hr className="my-4" />
            <Col sm={6}>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Número del Expediente</label>
                    <Input
                      id="numero_expediente"
                      name="numero_expediente"
                      type="number"
                      value={data.numero_expediente ?? ''}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col sm={6}>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Año del Expediente</label>
                    <Input
                      id="anio_expediente"
                      name="anio_expediente"
                      type="text"
                      value={data.anio_expediente ?? ''}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col sm={6}>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Número de Habilitación</label>
                    <Input
                      id="numero_habilitacion"
                      name="numero_habilitacion"
                      type="number"
                      value={data.numero_habilitacion ?? ''}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col sm={6}>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Fecha de Habilitación</label>
                    <Input
                      id="fecha_habilitacion"
                      name="fecha_habilitacion"
                      type="date"
                      value={data.fecha_habilitacion ?? ''}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <hr className="my-4" />
            <Col sm={6}>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Motivo de rechazo del ministerio</label>
                    <Input
                      id="motivo_rechazo"
                      name="motivo_rechazo"
                      type="textarea"
                      value={data.motivo_rechazo ?? ''}
                      onChange={handleInputChange}
                      disabled={isLoading}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col sm={12} className="text-center">
              <Button color="warning" onClick={() => onChangeState(6)} disabled={isLoading}>En Corrección</Button>
              <Button color="success" onClick={() => onChangeState(7)} disabled={isLoading}>
                Renovación Finalizada
              </Button>
            </Col>
          </Row>);
          break;
        default:
          return (null);
          break;
      }
    }
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    let value: string | number | boolean | null = target.value;
    if (target.type === 'checkbox') {
      value = target.checked;
    }

    // Guardamos el nuevo valor
    setData({
      ...data,
      [target.name]: value,
    });
  };

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <h6 className="heading text-muted mb-4">
            Matriculado
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Matricula</label>
                <p>{ data.matriculado.matricula || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Delegación</label>
                <p>{ data.matriculado.delegacion || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.matriculado.nombre || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.matriculado.apellido || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Consultorio
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Partido</label>
                <p>{ data.partido_name || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Localidad</label>
                <p>{ data.localidad_name || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Calle</label>
                <p>{ data.calle || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Número</label>
                <p>{ data.numero || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Piso</label>
                <p>{ data.piso || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Departamento</label>
                <p>{ data.departamento || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Código Postal</label>
                <p>{ data.codigo_postal || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          { data.state_id > 1
            ?
              <>
                <hr className="my-4" />
                <h6 className="heading text-muted mb-4">
                  Datos adicionales
                </h6>
                { data.state_id >= 5
                  ?
                    <>
                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <label className='form-control-label'>Número de Gestión</label>
                            <p>{ data.numero_gestion || '-' }</p>
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  : null
                }
                { data.state_id == 7
                  ?
                    <>
                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <label className='form-control-label'>Número del Expediente</label>
                            <p>{ data.numero_expediente || '-' }</p>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <label className='form-control-label'>Año del Expediente</label>
                            <p>{ data.anio_expediente || '-' }</p>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <label className='form-control-label'>Número de Habilitación</label>
                            <p>{ data.numero_habilitacion || '-' }</p>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <label className='form-control-label'>Fecha de Habilitación</label>
                            <p>{ data.fecha_habilitacion
                              ? moment(data.fecha_habilitacion).add(1, 'day').format('DD-MM-YYYY')
                              : '-'
                            }</p>
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  : null
                }
              </>
            : null
          }
          { [3, 6].includes(data.state_id) && !!data.motivo_rechazo
            ?
              <>
                <hr className="my-4" />
                <h6 className="heading text-muted mb-4">
                  Motivo Rechazo
                </h6>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <label className='form-control-label'>Motivo</label>
                      <p>{ data.motivo_rechazo || '-' }</p>
                    </FormGroup>
                  </Col>
                </Row>
              </>
            : null
          }
        </Col>
        <Col sm={6}>
          <div className="">
            <label className="form-control-label">Adjuntos</label>
            <div
              id="gallery-container"
              style={{ height: '80vh' }}
              ref={galleryContainer}
            >
              {Array.isArray(gallery) &&
              gallery.length &&
              galleryContainer.current ? (
                    <Viewer
                      container={galleryContainer.current}
                      noClose={true}
                      visible={true}
                      disableMouseZoom={true}
                      downloadable={true}
                      disableKeyboardSupport={true}
                      zoomSpeed={0.5}
                      downloadInNewWindow={true}
                      noImgDetails={true}
                      scalable={false}
                      showTotal={false}
                      defaultScale={1.25}
                      defaultImg={{
                        src: require('../../../assets/img/404.png'),
                      }}
                      images={gallery}
                    />
                  ) : null}
            </div>
          </div>
        </Col>
      </Row>
      { actionsByState() }
    </Form>
  );
}

export default RenovacionForm;
